/* eslint-disable max-len */
// This page contains all constants of the app. e.g. API urls
/// Description: https://xenia-software.atlassian.net/wiki/spaces/MOKAI/pages/6455341/1.0.0+API+Access+Management

import {UserAccountType} from './model/enums/enums'
import config from './mokai-firebase-config.json'

export const API_VERSION = 'v1'

// export const API_BASE_URL = `https://auth-proxy-2u7jfpcgga-ew.a.run.app/${API_VERSION}/`
export const API_BASE_URL = `${config.firebaseConfig.mokaiProxy}/${API_VERSION}/`

export const DOKAI_BASE_URL = 'https://help.mokai.ch/docs/app'
export const DOKAI_PAGE_NAME = 'Dokai'

// sent for start-up of the cloud run services (fire and forget)
export const API_WARM_UP_URL = `${config.firebaseConfig.mokaiProxy}/warmup`

// Get the claims for the logged in user
export const UPDATE_CLAIMS = 'admin/account/claims'

//export const GATEWAY_PROFESSION_API = (languageId: number) => `http://localhost:8080/https://red.gateway.one/Profession/List/${languageId}`
//export const GATEWAY_PROFESSION_API = (languageId: number) => `https://red.gateway.one/Profession/List/${languageId}`

// hrm

// companies
export const API_COMPANIES = (): string => 'companies'
export const API_COMPANIES_SHORT = (): string => `${API_COMPANIES()}?short=true`
export const API_COMPANY_BY_ID = (company_id: number): string => `${API_COMPANIES()}/${company_id}`

// accounts
export const API_ACCOUNTS = (): string => 'accounts'
export const API_ACCOUNT = (account_id: number): string => `${API_ACCOUNTS()}/${account_id}`

// profile get 000-001-006 and put 000-001-007
export const API_PROFILE = (): string => 'profile'

// profile picture
export const API_PROFILE_PICTURE_UPLOAD_SELF = () => `profilepicture`
export const API_PROFILE_PICTURE_UPLOAD = (id: number) => `profilepicture/${id}`

// persons
export const API_PERSONS = (): string => 'persons'
export const API_PERSON = (person_id: number): string => `persons/${person_id}`

// persons by account
export const API_PERSONS_BY_ACCOUNT = (type: UserAccountType): string => `${API_PERSONS()}?account_type=${type}`
export const API_PERSONS_BY_ACCOUNT_SHORT = (type: UserAccountType): string => `${API_PERSONS()}?account_type=${type}&short=true`

// apprentices
export const API_APPRENTICES = (): string => 'apprentices'
export const API_APPRENTICE = (apprentice_id: number): string => `apprentices/${apprentice_id}`

// groups
export const API_GROUPS = (): string => 'groups'
export const API_GROUPS_SHORT = (): string => `${API_GROUPS()}?short=true`
export const API_GROUP_BY_ID = (id: number): string => `${API_GROUPS()}/${id}`

export const API_GROUP_MEMBERS_BY_GROUP_ID = (groupId: number): string => `${API_GROUPS()}/${groupId}/member`
export const API_GROUP_MEMBERS_BY_GROUP_ID_AND_MEMBER_ID = (groupId: number, memberId: number): string => `${API_GROUPS()}/${groupId}/member/${memberId}`

// profession

export const API_PROFESSIONS = (): string => 'professions'


// documents

// trial period report
export const API_TRIAL_PERIOD_REPORTS = (): string => 'trial_period_reports'
export const API_TRIAL_PERIOD_REPORT = (id: number): string => `${API_TRIAL_PERIOD_REPORTS()}/${id}`
export const API_TRIAL_PERIOD_REPORT_GENERATE = (id: number): string => `${API_TRIAL_PERIOD_REPORT(id)}/generate`
export const API_TRIAL_PERIOD_REPORT_UPLOAD = (id: number): string => `${API_TRIAL_PERIOD_REPORT(id)}/upload`
export const API_TRIAL_PERIOD_REPORT_DOWNLOAD = (id: number): string => `${API_TRIAL_PERIOD_REPORT(id)}/download`
export const API_TRIAL_PERIOD_REPORT_FILE = (id: number): string => `${API_TRIAL_PERIOD_REPORTS()}/${id}/file`


// observations
export const API_OBSERVATIONS = (): string => 'observations'
export const API_OBSERVATION = (id: number): string => `${API_OBSERVATIONS()}/${id}`
export const API_OBSERVATIONS_BY_APPRENTICE = (apprenticeId: number): string => `${API_OBSERVATIONS()}?id_apprentice=${apprenticeId}`

export const API_OBSERVATION_DOWNLOAD = (id: number): string => `${API_OBSERVATIONS()}/${id}/download`

export const API_OBSERVATION_UPLOAD = (id: number): string => `${API_OBSERVATIONS()}/${id}/upload`
export const API_OBSERVATION_FILE = (observationFileId: number): string => `${API_OBSERVATIONS()}/file/${observationFileId}`
//export const API_OBSERVATION_FILE_DOWNLOAD = (observationFileId: number): string => `${API_OBSERVATION_FILE}/download`

// education report
export const API_EDUCATION_REPORTS = (): string => `education_reports`
export const API_EDUCATION_REPORT = (reportId: number): string => `${API_EDUCATION_REPORTS()}/${reportId}`
export const API_EDUCATION_REPORT_FILE = (reportId: number): string => `${API_EDUCATION_REPORTS()}/${reportId}/file`
export const API_EDUCATION_REPORT_UPLOAD = (reportId: number): string => `${API_EDUCATION_REPORTS()}/${reportId}/upload`
export const API_EDUCATION_REPORT_DOWNLOAD = (reportId: number): string => `${API_EDUCATION_REPORT(reportId)}/download`
export const API_EDUCATION_REPORT_GENERATE = (reportId: number): string => `${API_EDUCATION_REPORTS()}/${reportId}/generate`
export const API_EDUCATION_REPORT_BY_APPRENTICE_SEMESTER = (apprenticeId: number, semester: number): string => `education_reports?id_apprentice=${apprenticeId}&semester_report=${semester}`

// dossier
export const API_DOSSIERS = (): string => `dossiers`
export const API_DOSSIER = (dossierId: number): string => `${API_DOSSIERS()}/${dossierId}`
export const API_DOSSIER_PERSON = (personId: number): string => `${API_DOSSIERS()}?id_person=${personId}`

export const API_DOSSIER_FILE = (fileId: number): string => `${API_DOSSIERS()}/${fileId}`

// document types
export const API_DOCUMENT_TYPES = (): string => `document_types`
export const API_DOCUMENT_TYPE = (typeId: number): string => `${API_DOCUMENT_TYPES}/${typeId}`


// modules

export const API_APPRENTICESHIP_MODULES = (): string => 'apprenticeship_modules'
export const API_APPRENTICESHIP_MODULE = (moduleId: number): string => `${API_APPRENTICESHIP_MODULES()}/${moduleId}`

export const API_APPRENTICESHIP_MODULE_PLANS = (): string => 'apprenticeship_module_plans'
export const API_APPRENTICESHIP_MODULE_PLAN = (planId: number): string => `${API_APPRENTICESHIP_MODULE_PLANS()}/${planId}`

export const API_APPRENTICESHIP_MODULE_TYPES = (): string => 'apprenticeship_module_types'
export const API_APPRENTICESHIP_MODULE_TYPE = (id: number): string => `${API_APPRENTICESHIP_MODULE_TYPES()}/${id}`

// grades 000-xxx-xxx API Calls
export const API_GRADE_SCHEMAS = (): string => 'grade_schemas'
export const API_GRADE_SCHEMA = (id: number): string => `${API_GRADE_SCHEMAS()}/${id}`

export const API_GRADE_TYPES = (): string => 'grade_types'
export const API_GRADE_TYPE = (id: number): string => `${API_GRADE_TYPES()}/${id}`

export const API_GRADE_VALUES = (): string => 'grade_values'
export const API_GRADE_VALUES_BY_SCHEMA = (id: number): string => `grade_values?id_grade_schema=${id}`
export const API_GRADE_VALUE = (id: number): string => `${API_GRADE_VALUES()}/${id}`

export const API_ROUNDING_TYPES = (): string => 'rounding_types'
export const API_ROUNDING_TYPE = (id: number): string => `${API_ROUNDING_TYPES()}/${id}`

export const API_DOCUMENT_STATUSES = (): string => 'document_statuses'
export const API_DOCUMENT_STATUS = (id: number): string => `${API_DOCUMENT_STATUSES()}/${id}`

export const API_APPRENTICESHIP_TYPES = (): string => 'apprenticeship_types'
export const API_APPRENTICESHIP_TYPE = (id: number): string => `${API_DOCUMENT_STATUSES()}/${id}`

// grades 004-xxx-xxx calls

export const API_GRADES = (): string => 'grades'
export const API_GRADE = (id: number): string => `${API_GRADES}/${id}`
export const API_GRADE_CONTAINERS = (): string => 'grade_containers'
export const API_GRADE_CONTAINER = (id: number): string => `${API_GRADE_CONTAINERS()}/${id}`

export const API_APPRENTICESHIP_MODULE_GRADES = (): string => 'apprentice_module_grades'

export const API_APPRENTICESHIP_MODULE_GRADE_BULK_CREATE = (): string =>
	`${API_APPRENTICESHIP_MODULE_GRADES()}/bulk`
export const API_APPRENTICESHIP_MODULE_GRADE = (id: number): string =>
	`${API_APPRENTICESHIP_MODULE_GRADES()}/${id}`

export const API_ANALYZE = (): string => 'analyze'

export const API_LEARNING_JOURNALS = () : string => 'learning_journals'
export const API_LEARNING_JOURNALS_SHORT = () : string => `${API_LEARNING_JOURNALS()}?short=true`
export const API_LEARNING_JOURNAL = (id: number) : string =>`${API_LEARNING_JOURNALS()}/${id}`
export const API_LEARNING_JOURNAL_UPLOAD = (id: number) => `${API_LEARNING_JOURNAL(id)}/upload`
export const API_LEARNING_JOURNAL_REVIEW = (id: number) => `${API_LEARNING_JOURNAL(id)}/review`
export const API_LEARNING_JOURNAL_EDIT = (id: number) => `${API_LEARNING_JOURNAL(id)}/edit` 
export const API_LEARNING_JOURNAL_FILE = (id: number) => `${API_LEARNING_JOURNALS()}/file/${id}` 
export const API_LEARNING_JOURNAL_FILE_DOWNLOAD = (id: number) => `${API_LEARNING_JOURNAL_FILE(id)}/download` 





// post
//export const API_POST_PROXY = "https://swisspost.opendatasoft.com/explore/dataset/plz_verzeichnis_v2/api/records/1.0/search/?dataset=plz_verzeichnis_v2&q=2108&facet=postleitzahl&facet=plz_zz&facet=ortbez18"
//https://webservices.post.ch:17023/IN_SYNSYN_EXT/REST/v1/autocomplete4
export const API_POST_PROXY = 'https://post-proxy-bbxmrvfqlq-oa.a.run.app/IN_SYNSYN_EXT/REST/v1/autocomplete4'
//export const API_POST_PROXY = 'https://post-proxy-bbxmrvfqlq-oa.a.run.app/IN_SYNSYN_EXT/REST/v1/autocomplete4'
export const POST_TOKEN = window.btoa('TU_6072884_0001:kBh4fNtY')


// other constants for multiupload
export const MAX_FILE_SIZE = 200000000
export const MAX_JOURNAL_SIZE = 10000000
export const MAX_MULTIUPLOAD = 10
export const MAX_JOURNAL_MULTIUPLOAD = 4

export const MAX_DOSSIER_SIZE = 200000000